<template>
	<div
		class="notification"
		v-lazy:background-image="'/images/home/notification-back.jpg'"
		v-if="!isClosed"
	>
		<div class="notify-content text-white" style="display:flex">
			<p>
				<span style="color:black"><b>We are migrating to a new website! <a href="https://airabica.coffee/">airabica.coffee</a></b>&nbsp;</span>
				<span style="color:#68331c; font-weight:500">Kindly place coffee orders on the new site</span>
				<span style="color:#68331c; font-weight:500">Pls. be patient while we migrate the rest of the products or contact us to place equipment orders</span>
			 </p>
			 <!-- <p><strong>FREE</strong> Shipping within ZA for all orders over R{{minFreeShip}}</p> -->
		</div>
		<div class="notify-action">
			<a @click.prevent="closeTopnotice"><i class="icon-close"></i></a>
		</div>
	</div>
</template>
<script>

import { minValueFreeShip } from '~/utilities/data';
export default {
	data: function() {
		return {
			isClosed: false,
			minFreeShip: minValueFreeShip
		};
	},
	methods: {
		closeTopnotice: function() {
			this.isClosed = true;
		}
	}
};
</script>